/* Dal Ninja · original, dependency-free canvas game. Shared local theme images only. */
(function () {
  'use strict';
  const TYPES = ['tomato', 'onion', 'chilli'];
  const clamp = (n, a, b) => Math.max(a, Math.min(b, n));
  function segmentDistance(x, y, ax, ay, bx, by) {
    const dx = bx - ax, dy = by - ay, length = dx * dx + dy * dy;
    const t = length ? clamp(((x - ax) * dx + (y - ay) * dy) / length, 0, 1) : 0;
    return Math.hypot(x - ax - t * dx, y - ay - t * dy);
  }
  class Round {
    constructor(random) { this.random = random || Math.random; this.reset(false); }
    reset(calm) {
      this.calm = calm; this.state = 'idle'; this.score = 0; this.time = 30;
      this.targets = []; this.next = 0; this.clock = 0; this.spawnClock = 0;
      this.foodIndex = 0; this.nextBombAt = 4.5; this.reason = '';
      this.width = 500; this.height = 330;
    }
    start() { this.state = 'playing'; this.spawnClock = 1; }
    pause() { if (this.state === 'playing') this.state = 'paused'; }
    resume() { if (this.state === 'paused') this.state = 'playing'; }
    spawn() {
      const bomb = this.clock >= this.nextBombAt && !this.targets.some(target => target.type === 'bomb');
      const type = bomb ? 'bomb' : TYPES[this.foodIndex++ % 3], index = TYPES.indexOf(type);
      if (this.calm && this.targets.some(target => target.type === type)) return;
      if (bomb) this.nextBombAt = this.clock + 2.8 + this.random() * 1.3;
      const radius = clamp(this.width * .066, 21, 34);
      this.targets.push({
        id: ++this.next, type, radius, age: 0,
        x: this.calm ? this.width * (bomb ? .5 : .21 + index * .29) : this.width * (.2 + this.random() * .6),
        y: this.calm ? this.height * (bomb ? .73 : .43 + (index === 1 ? -.12 : .02)) : this.height + radius,
        vx: (this.random() - .5) * this.width * .24,
        vy: -(this.height * 1.15 + this.random() * 85),
        angle: (this.random() - .5) * .5, spin: (this.random() - .5) * 2
      });
    }
    tick(seconds) {
      if (this.state !== 'playing') return;
      const dt = Math.max(0, seconds);
      this.time = Math.max(0, this.time - dt); this.clock += dt;
      if (!this.time) { this.state = 'finished'; this.reason = 'time'; return; }
      this.spawnClock += Math.min(dt, .2);
      const interval = this.calm ? .45 : .62;
      if (this.spawnClock >= interval && this.targets.length < 6) { this.spawnClock = 0; this.spawn(); }
      this.targets.forEach(target => {
        target.age += dt;
        if (!this.calm) {
          const step = Math.min(dt, .05);
          target.x += target.vx * step; target.y += target.vy * step;
          target.vy += this.height * 1.34 * step; target.angle += target.spin * step;
        }
      });
      this.targets = this.targets.filter(target => this.calm ? target.age < (target.type === 'bomb' ? 2.8 : 4) : target.y < this.height + target.radius * 3 && target.age < 8);
    }
    visible(target) { return target.y > -target.radius && target.y < this.height - 10; }
    collect(test) {
      if (this.state !== 'playing') return [];
      const hits = this.targets.filter(target => this.visible(target) && (target.type !== 'bomb' || target.age >= .75) && test(target));
      this.targets = this.targets.filter(target => !hits.includes(target));
      if (hits.some(target => target.type === 'bomb')) { this.state = 'finished'; this.reason = 'bomb'; return hits; }
      this.score += hits.length * 10;
      return hits;
    }
    slice(ax, ay, bx, by) { return this.collect(t => segmentDistance(t.x, t.y, ax, ay, bx, by) <= t.radius + 7); }
    hitType(type) {
      if (!TYPES.includes(type)) return [];
      const target = this.targets.find(t => t.type === type && this.visible(t));
      return target ? this.collect(t => t.id === target.id) : [];
    }
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { Round, segmentDistance };
  if (typeof document === 'undefined') return;
  if (window.TFDalNinja) { window.TFDalNinja.mount(document); return; }

  function create(root) {
    if (root.tfDalNinja) return;
    const $ = name => root.querySelector('[data-ninja-' + name + ']');
    const canvas = $('canvas'), ctx = canvas && canvas.getContext('2d');
    if (!ctx) return;
    const game = new Round(), stage = $('stage'), overlay = $('overlay'), play = $('play');
    const hitButtons = Array.from(root.querySelectorAll('[data-ninja-hit]'));
    const cleanups = [], reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const photos = {}; let photosPending = TYPES.length;
    let calm = reduced.matches, best = 0, frame = 0, last = 0, pointer = null;
    let particles = [], marks = [], streak = [], visible = true, dead = false, comboTimer = 0;
    let chain = 0, lastHit = -10, displayedTime = 30, displayedScore = -1, displayedState = '', width = 0, height = 0;
    try { best = Number(localStorage.getItem('tpfu-dal-ninja-best')) || 0; } catch (_) { /* Storage is optional. */ }
    $('best').textContent = String(best); $('game').hidden = false;
    const on = (node, event, handler, options) => { node.addEventListener(event, handler, options); cleanups.push(() => node.removeEventListener(event, handler, options)); };
    const status = message => { $('status').textContent = message; };
    function loadPhotos() {
      play.disabled = true; play.textContent = 'Loading ingredients…';
      TYPES.forEach(type => {
        const photo = new Image(); photo.decoding = 'async';
        photos[type] = { image: photo, state: 'loading' };
        let settled = false, timer = 0;
        const settle = loaded => {
          if (settled || dead) return;
          settled = true; clearTimeout(timer); photo.onload = null; photo.onerror = null;
          photos[type].state = loaded ? 'loaded' : 'error'; photosPending--;
          if (!photosPending) {
            play.disabled = false; play.innerHTML = 'Let’s play <span aria-hidden="true">↗</span>';
            status('Ingredients are ready. Select Let’s play to start.');
          }
          draw();
        };
        photo.onload = () => settle(photo.naturalWidth > 0 && photo.naturalHeight > 0);
        photo.onerror = () => settle(false);
        timer = setTimeout(() => settle(false), 10000);
        cleanups.push(() => { clearTimeout(timer); photo.onload = null; photo.onerror = null; });
        const source = root.getAttribute('data-ninja-' + type + '-src');
        if (source) photo.src = source; else settle(false);
      });
    }
    function setMode() {
      $('mode').setAttribute('aria-pressed', String(calm));
      $('mode').textContent = calm ? 'Calm mode on' : 'Calm mode';
      $('hint').textContent = calm ? 'Still targets. Avoid bombs.' : 'Swipe ingredients. Avoid bombs.';
    }
    function updateButtons() {
      hitButtons.forEach(button => {
        const available = game.state === 'playing' && game.targets.some(t => t.type === button.dataset.ninjaHit && game.visible(t));
        if (button.disabled === available) button.disabled = !available;
      });
    }
    function sync() {
      if (displayedScore !== game.score) { $('score').textContent = String(game.score); displayedScore = game.score; }
      const seconds = Math.ceil(game.time);
      if (seconds !== displayedTime) { $('time').textContent = String(seconds); displayedTime = seconds; $('time').parentElement.classList.toggle('is-low', seconds <= 5 && game.state === 'playing'); }
      if (displayedState !== game.state) {
        stage.dataset.state = game.state; displayedState = game.state;
        stage.dataset.reason = game.reason;
        $('pause').disabled = !['playing', 'paused'].includes(game.state);
        $('pause').textContent = game.state === 'paused' ? 'Restart' : 'Pause';
        $('time').parentElement.classList.toggle('is-low', seconds <= 5 && game.state === 'playing');
      }
      updateButtons();
    }
    function fit() {
      const box = stage.getBoundingClientRect();
      if (!box.width || !box.height || (width === box.width && height === box.height)) return;
      const oldWidth = width || box.width, oldHeight = height || box.height;
      width = box.width; height = box.height;
      game.targets.forEach(t => { t.x *= width / oldWidth; t.y *= height / oldHeight; });
      game.width = width; game.height = height;
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.round(width * dpr); canvas.height = Math.round(height * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0); draw();
    }
    function food(type, x, y, radius, angle, opacity) {
      const photo = photos[type];
      if (type !== 'bomb' && (!photo || photo.state === 'loading')) return;
      ctx.save(); ctx.translate(x, y); ctx.rotate(angle || 0); ctx.scale(radius / 30, radius / 30);
      ctx.globalAlpha = opacity === undefined ? 1 : opacity;
      ctx.shadowColor = '#11160b55'; ctx.shadowBlur = 10; ctx.shadowOffsetY = 6;
      if (photo && photo.state === 'loaded') {
        const ratio = photo.image.naturalWidth / photo.image.naturalHeight;
        const imageWidth = ratio >= 1 ? 66 : 66 * ratio, imageHeight = ratio >= 1 ? 66 / ratio : 66;
        ctx.drawImage(photo.image, -imageWidth / 2, -imageHeight / 2, imageWidth, imageHeight);
        ctx.restore(); return;
      }
      if (type === 'bomb') {
        ctx.fillStyle = '#202323'; ctx.strokeStyle = '#f6edd6'; ctx.lineWidth = 2.4;
        ctx.beginPath(); ctx.arc(0, 3, 27, 0, Math.PI * 2); ctx.fill(); ctx.stroke(); ctx.shadowBlur = 0; ctx.shadowOffsetY = 0;
        ctx.fillStyle = '#505756'; ctx.beginPath(); ctx.ellipse(-10, -8, 6, 10, .65, 0, Math.PI * 2); ctx.fill();
        ctx.fillStyle = '#e5c186'; ctx.fillRect(-6, -31, 12, 9);
        ctx.strokeStyle = '#f1ce8e'; ctx.lineWidth = 3; ctx.beginPath(); ctx.moveTo(0, -30); ctx.quadraticCurveTo(-3, -44, 13, -40); ctx.stroke();
        ctx.strokeStyle = '#efb544'; ctx.lineWidth = 2; ctx.beginPath(); ctx.moveTo(14, -47); ctx.lineTo(14, -35); ctx.moveTo(8, -41); ctx.lineTo(20, -41); ctx.moveTo(10, -45); ctx.lineTo(18, -37); ctx.stroke();
        ctx.strokeStyle = '#f7e8d2'; ctx.lineWidth = 4; ctx.lineCap = 'round'; ctx.beginPath(); ctx.moveTo(-7, -3); ctx.lineTo(7, 11); ctx.moveTo(7, -3); ctx.lineTo(-7, 11); ctx.stroke();
      } else if (type === 'tomato') {
        ctx.fillStyle = '#ed6044'; ctx.beginPath(); ctx.ellipse(0, 2, 29, 27, 0, 0, Math.PI * 2); ctx.fill(); ctx.shadowBlur = 0; ctx.shadowOffsetY = 0;
        ctx.fillStyle = '#cb3827'; ctx.beginPath(); ctx.ellipse(10, 6, 15, 22, .3, -.9, 2.4); ctx.fill();
        ctx.fillStyle = '#ff9870'; ctx.beginPath(); ctx.ellipse(-12, -6, 6, 12, .6, 0, Math.PI * 2); ctx.fill();
        ctx.fillStyle = '#698344'; ctx.beginPath(); ctx.moveTo(0, -25); ctx.lineTo(9, -31); ctx.lineTo(6, -22); ctx.lineTo(18, -17); ctx.lineTo(5, -17); ctx.lineTo(-1, -9); ctx.lineTo(-5, -18); ctx.lineTo(-17, -16); ctx.lineTo(-7, -24); ctx.lineTo(-11, -31); ctx.closePath(); ctx.fill();
        ctx.strokeStyle = '#a4b86b'; ctx.lineWidth = 3; ctx.beginPath(); ctx.moveTo(-1, -22); ctx.quadraticCurveTo(1, -33, 8, -34); ctx.stroke();
      } else if (type === 'onion') {
        ctx.fillStyle = '#b594bd'; ctx.beginPath(); ctx.ellipse(0, 2, 27, 29, -.1, 0, Math.PI * 2); ctx.fill(); ctx.shadowBlur = 0; ctx.shadowOffsetY = 0;
        ['#e1c7df', '#ae88b7', '#f1deeb', '#b896c2', '#eddae7', '#c4a9cf', '#f7e8ed'].forEach((color, i) => {
          ctx.strokeStyle = color; ctx.lineWidth = 3; ctx.beginPath(); ctx.ellipse(0, 2, 23 - i * 3, 25 - i * 3, -.1, 0, Math.PI * 2); ctx.stroke();
        });
        ctx.fillStyle = '#ead7c0'; ctx.beginPath(); ctx.moveTo(-6, -24); ctx.lineTo(-2, -36); ctx.lineTo(3, -25); ctx.fill();
      } else {
        ctx.fillStyle = '#92ad62'; ctx.beginPath(); ctx.moveTo(-25, -15); ctx.bezierCurveTo(0, -33, 35, -11, 25, 15); ctx.bezierCurveTo(18, 32, -8, 36, -27, 30); ctx.bezierCurveTo(12, 17, 9, 3, -25, -3); ctx.closePath(); ctx.fill(); ctx.shadowBlur = 0; ctx.shadowOffsetY = 0;
        ctx.strokeStyle = '#bed888'; ctx.lineWidth = 3; ctx.lineCap = 'round'; ctx.beginPath(); ctx.moveTo(-14, -12); ctx.bezierCurveTo(12, -16, 28, -3, 9, 18); ctx.stroke();
        ctx.strokeStyle = '#d9c596'; ctx.lineWidth = 5; ctx.beginPath(); ctx.moveTo(-24, -10); ctx.quadraticCurveTo(-36, -17, -31, -27); ctx.stroke();
      }
      ctx.restore();
    }
    function draw() {
      if (dead || !width) return;
      ctx.clearRect(0, 0, width, height);
      if (game.state === 'idle' || game.state === 'finished') {
        food('tomato', width * .12, height * .17, 24, -.3, .85);
        food('onion', width * .85, height * .23, 25, .2, .8);
        food('chilli', width * .82, height * .66, 29, -.5, .85);
        food('onion', width * .13, height * .69, 21, -.4, .65);
        ctx.save(); ctx.strokeStyle = '#7e836155'; ctx.lineWidth = 1; ctx.setLineDash([3, 6]); ctx.beginPath();
        ctx.ellipse(width * .49, height * .47, width * .41, height * .4, -.2, .3, 2.8); ctx.stroke(); ctx.restore();
        return;
      }
      game.targets.forEach(t => food(t.type, t.x, t.y, t.radius, t.type === 'bomb' && calm ? 0 : t.angle, t.type === 'bomb' && t.age < .75 ? .55 : 1));
      particles.forEach(p => {
        ctx.globalAlpha = Math.max(0, p.life / p.max); ctx.fillStyle = p.color;
        ctx.beginPath(); ctx.ellipse(p.x, p.y, p.size, p.size * .65, p.life * 4, 0, Math.PI * 2); ctx.fill();
      });
      ctx.globalAlpha = 1;
      if (streak.length > 1 && !calm) {
        ctx.save(); ctx.strokeStyle = '#fff1b9'; ctx.lineWidth = 4; ctx.lineCap = 'round'; ctx.lineJoin = 'round';
        ctx.shadowColor = '#efb544'; ctx.shadowBlur = 10; ctx.beginPath();
        streak.forEach((p, i) => { if (i) ctx.lineTo(p.x, p.y); else ctx.moveTo(p.x, p.y); }); ctx.stroke(); ctx.restore();
      }
      marks.forEach(p => {
        ctx.globalAlpha = Math.min(1, p.life * 2); ctx.fillStyle = '#ffdfa0'; ctx.font = '800 22px Arial, sans-serif'; ctx.textAlign = 'center';
        ctx.fillText('+10', p.x, p.y);
      });
      ctx.globalAlpha = 1;
    }
    function collect(hits) {
      if (!hits.length) return;
      if (game.reason === 'bomb') { finish(); return; }
      hits.forEach(t => {
        marks.push({ x: t.x, y: t.y, life: .75 });
        if (!calm) for (let i = 0; i < 8; i++) {
          particles.push({ x: t.x, y: t.y, vx: (Math.random() - .5) * 190, vy: (Math.random() - .65) * 180,
            size: 3 + Math.random() * 5, life: .65, max: .65,
            color: t.type === 'tomato' ? '#ef7752' : t.type === 'onion' ? '#d6b9da' : '#abc979' });
        }
      });
      particles = particles.slice(-64); marks = marks.slice(-8);
      chain = game.clock - lastHit < 1 ? chain + hits.length : hits.length; lastHit = game.clock;
      if (chain >= 3) {
        $('combo').textContent = 'NICE TADKA!'; clearTimeout(comboTimer);
        comboTimer = setTimeout(() => { $('combo').textContent = ''; }, 850); chain = 0;
      }
      sync(); status(game.score + ' points. ' + Math.ceil(game.time) + ' seconds left.');
    }
    function showOverlay(note, heading, message, label) {
      $('note').textContent = note; $('heading').textContent = heading; $('message').textContent = message;
      play.innerHTML = label + ' <span aria-hidden="true">↗</span>'; overlay.hidden = false;
    }
    function finish() {
      cancelAnimationFrame(frame); frame = 0; pointer = null; particles = []; marks = []; streak = [];
      $('combo').textContent = ''; clearTimeout(comboTimer);
      const record = game.score > best;
      if (record) { best = game.score; $('best').textContent = String(best); try { localStorage.setItem('tpfu-dal-ninja-best', String(best)); } catch (_) { /* Optional. */ } }
      if (game.reason === 'bomb') showOverlay('BOMB SLICED. ROUND OVER.', 'Oops. Extra spicy.', game.score + ' points. Dodge the bombs and keep the tadka going. Ready for another round?', 'Play again');
      else showOverlay(record ? 'A NEW PERSONAL BEST.' : 'TADKA COMPLETE.', game.score ? 'Chef’s kiss.' : 'Warm-up complete.', game.score + ' points. We’ll take care of the real cooking.', 'Play again');
      sync(); draw(); status((game.reason === 'bomb' ? 'Bomb sliced. Round over. ' : 'Round complete. ') + game.score + ' points. Play again or choose your meal plan.');
      if (root.contains(document.activeElement)) play.focus({ preventScroll: true });
    }
    function loop(now) {
      frame = 0;
      if (dead || game.state !== 'playing') return;
      const dt = last ? Math.max(0, (now - last) / 1000) : 0; last = now;
      game.tick(dt);
      if (game.state === 'finished') { finish(); return; }
      particles.forEach(p => { p.x += p.vx * dt; p.y += p.vy * dt; p.vy += 180 * dt; p.life -= dt; });
      particles = particles.filter(p => p.life > 0);
      marks.forEach(p => { p.life -= dt; if (!calm) p.y -= dt * 30; }); marks = marks.filter(p => p.life > 0);
      streak.forEach(p => { p.life -= dt; }); streak = streak.filter(p => p.life > 0);
      sync(); draw(); frame = requestAnimationFrame(loop);
    }
    function start() {
      if (photosPending) return;
      game.reset(calm); game.width = width; game.height = height; game.start();
      particles = []; marks = []; streak = []; chain = 0; lastHit = -10; last = 0;
      clearTimeout(comboTimer); $('combo').textContent = ''; overlay.hidden = true;
      sync(); cancelAnimationFrame(frame); frame = requestAnimationFrame(loop);
      status('Round started. 30 seconds. Slice ingredients and avoid bombs. A bomb ends the round. Ingredient buttons and keys 1, 2 and 3 are also available.'); $('pause').focus({ preventScroll: true });
    }
    function pause(reason) {
      if (game.state !== 'playing') return;
      game.pause(); cancelAnimationFrame(frame); frame = 0; pointer = null; streak = [];
      showOverlay('TAKE YOUR TIME.', 'Tadka on hold.', reason || 'Your score and remaining time are saved for this round.', 'Resume');
      sync(); draw(); status('Game paused. Select Resume to continue.');
    }
    function resume() {
      if (!visible || document.hidden) return;
      game.resume(); overlay.hidden = true; last = 0; sync(); frame = requestAnimationFrame(loop);
      status('Game resumed. ' + Math.ceil(game.time) + ' seconds left.'); $('pause').focus({ preventScroll: true });
    }
    const position = event => { const box = canvas.getBoundingClientRect(); return { x: event.clientX - box.left, y: event.clientY - box.top, life: .13 }; };
    on(play, 'click', () => game.state === 'paused' ? resume() : start());
    on($('pause'), 'click', () => { if (game.state === 'playing') { pause(); play.focus({ preventScroll: true }); } else if (game.state === 'paused') start(); });
    on($('mode'), 'click', () => {
      calm = !calm; setMode(); game.calm = calm; game.targets = []; game.spawnClock = 1;
      particles = []; marks = []; streak = [];
      if (game.state === 'playing') pause(calm ? 'Calm mode uses still ingredients, with bombs in a separate lower lane. Ingredient buttons and keys 1–3 stay safe.' : 'Swipe ingredients and avoid bombs. Ready when you are.');
      else draw();
      status(calm ? 'Calm mode on. Ingredients stay still.' : 'Calm mode off. Ingredients move.');
    });
    hitButtons.forEach(button => on(button, 'click', () => { collect(game.hitType(button.dataset.ninjaHit)); if (button.disabled && game.state === 'playing') $('pause').focus({ preventScroll: true }); }));
    on(root, 'keydown', event => {
      if (event.ctrlKey || event.altKey || event.metaKey || /INPUT|TEXTAREA|SELECT/.test(event.target.tagName)) return;
      const index = ['1', '2', '3'].indexOf(event.key);
      if (index >= 0 && game.state === 'playing') { event.preventDefault(); if (!event.repeat) collect(game.hitType(TYPES[index])); }
      if (event.key === 'Escape' && game.state === 'playing') { pause(); play.focus({ preventScroll: true }); }
    });
    on(canvas, 'pointerdown', event => {
      if (game.state !== 'playing' || (event.pointerType === 'mouse' && event.button !== 0)) return;
      event.preventDefault(); pointer = position(event); pointer.id = event.pointerId;
      canvas.setPointerCapture(event.pointerId); collect(game.slice(pointer.x, pointer.y, pointer.x, pointer.y));
      if (pointer) streak.push({ ...pointer });
    });
    on(canvas, 'pointermove', event => {
      if (!pointer || game.state !== 'playing' || pointer.id !== event.pointerId) return;
      event.preventDefault(); const next = position(event);
      collect(game.slice(pointer.x, pointer.y, next.x, next.y));
      if (game.state !== 'playing') return;
      pointer = { ...next, id: event.pointerId };
      if (!calm) { streak.push(next); streak = streak.slice(-10); }
    });
    const release = event => { if (pointer && pointer.id === event.pointerId) { pointer = null; if (canvas.hasPointerCapture(event.pointerId)) canvas.releasePointerCapture(event.pointerId); } };
    on(canvas, 'pointerup', release); on(canvas, 'pointercancel', release); on(canvas, 'lostpointercapture', () => { pointer = null; });
    on(document, 'visibilitychange', () => { if (document.hidden) pause('Paused while you were away. Ready for another slice?'); });
    on(window, 'blur', () => pause('Paused while you were away. Ready for another slice?'));
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .2;
        if (!visible) pause('Your tadka can wait. Resume whenever you’re ready.');
      }, { threshold: [0, .2] });
      observer.observe(stage); cleanups.push(() => observer.disconnect());
    }
    if ('ResizeObserver' in window) { const observer = new ResizeObserver(fit); observer.observe(stage); cleanups.push(() => observer.disconnect()); }
    else on(window, 'resize', fit);
    const onReduced = event => { if (event.matches && !calm) { calm = true; setMode(); game.calm = true; game.targets = []; pause('Calm mode is on to keep motion gentle.'); draw(); } };
    if (reduced.addEventListener) on(reduced, 'change', onReduced);
    setMode(); fit(); sync(); loadPhotos();
    root.tfDalNinja = { destroy() { dead = true; cancelAnimationFrame(frame); clearTimeout(comboTimer); cleanups.forEach(cleanup => cleanup()); delete root.tfDalNinja; } };
  }
  function boot(scope) { (scope || document).querySelectorAll('[data-tf-ninja]').forEach(create); }
  window.TFDalNinja = { mount: boot };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
  else boot();
  document.addEventListener('shopify:section:load', event => boot(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-tf-ninja]').forEach(root => { if (root.tfDalNinja) root.tfDalNinja.destroy(); }));
}());
